import React from 'react';
import { AccountsDisplay, CountryBankSelector } from './';
import { ConverterType, Account } from '../types';
import { ActualServer } from '../types';
import { useAccountConfiguration } from '../hooks/useAccountConfiguration';
import type { AccountConfiguration } from '../hooks/useAccountConfiguration';

interface ToolSelectorProps {
  activeConverter: ConverterType;
  onConverterChange: (converter: ConverterType) => void;
  activeServer: ActualServer | null;
  onAccountSelect: (account: Account, config: AccountConfiguration) => void;
  onAccountDeselect?: () => void;
  accountConfig: ReturnType<typeof useAccountConfiguration>;
  onShowAccountSettings?: (account: Account) => void;
  onLinkAccount?: (account: Account) => void;
  user?: any;
}

const ToolSelector: React.FC<ToolSelectorProps> = ({ 
  activeConverter, 
  onConverterChange, 
  activeServer,
  onAccountSelect,
  onAccountDeselect,
  accountConfig,
  onShowAccountSettings,
  onLinkAccount,
  user
}) => {
  const hasLinkedAccountSelected = Boolean(accountConfig?.selectedAccountId);
  const showCountryBankSelector =
    !user ||
    !activeServer ||
    !activeServer.defaultBudgetId ||
    !hasLinkedAccountSelected;

  return (
    <div className="tools-section">
      {/* Show accounts from active server for logged-in users */}
      {user && activeServer && activeServer.defaultBudgetId && accountConfig && (
        <AccountsDisplay 
          activeServer={activeServer}
          onAccountSelect={onAccountSelect}
          onAccountDeselect={onAccountDeselect}
          accountConfig={accountConfig}
          onShowSettings={onShowAccountSettings}
          onLinkAccount={onLinkAccount}
        />
      )}
      
      {/* Show country/bank selector when logged out or no linked account is selected */}
      {showCountryBankSelector && (
        <CountryBankSelector 
          onConverterChange={onConverterChange} 
          activeConverter={activeConverter}
        />
      )}
    </div>
  );
};

export default ToolSelector; 